module.exports = __webpack_public_path__ + "static/media/recruit_230_default0.77e74583.png";